import { BASE_URL, COMPANY_JOB_COMPETENCY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompanyJobCompetencyInput } from "models/CompanyJobCompetency";


export async function getCompanyJobCompetencies(params: string = "") {
  const response = await axios.get(BASE_URL + COMPANY_JOB_COMPETENCY + params);
  return response.data;
}
export async function addCompanyJobCompetency(data: ICompanyJobCompetencyInput) {
  const response = await axios.post(BASE_URL + COMPANY_JOB_COMPETENCY, data);
  return response.data;
}

export async function deleteCompanyJobCompetency(id: string) {
  const response = await axios.delete(BASE_URL + COMPANY_JOB_COMPETENCY + "/" + id);
  return response.data;
}

export const CompanyJobCompetenciesCells: HeadCell[] = [

  {
    id: "competencyName",
    numeric: false,
    disablePadding: false,
    label: "T_competency_name",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
